import { ChangeEvent, Fragment, HTMLAttributes } from "react";
import { makeStyles, Theme, createStyles, Typography, TextField } from "@material-ui/core";
import clsx from 'clsx';
import { observer } from "mobx-react";
import FormError from "../../../../Organization/VolunteerOpportunities/FormError";
import { OrganizationAdminInvite } from "../../../../../stores/models/OrganizationAdminInvite";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formFields: {
            display: 'flex',
            flexDirection: 'column',
            '& > *': {
                '&:not(:last-child)': {
                    marginBottom: theme.spacing(2),
                },
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                '& > *': {
                    flexGrow: 1
                }
            }
        },
        fieldTitle: {
            fontWeight: 'bold'
        },
        required: {
            color: 'red'
        },
        emailInvitationAlert: {
            marginBottom: theme.spacing(2)
        },
    })
);

interface AddAdminFormProps extends HTMLAttributes<HTMLDivElement> {
    newRecord: OrganizationAdminInvite;
    error?: boolean;
}

const AddAdminForm = observer((props: AddAdminFormProps) => {

    const classes = useStyles();
    const newRecord = props.newRecord;
    const emailFieldError = newRecord.getErrorForField('email');

    /********** Event Handlers *********/

    const onEmailChanged = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.target.value !== undefined) {
            newRecord.setEmail(event.target.value);
        }
    }

    /********** Render *********/

    return (
        <Fragment>
            {props.error && <FormError />}
            <div className={clsx(classes.formFields, props.className)}>
                <div>
                    Invite another person to be an administrator for your organization by entering their email address below.
                </div>
                <div>
                    <Typography className={classes.fieldTitle}>
                        Email<span className={classes.required}> *</span>
                    </Typography>
                    <TextField
                        id="standard-email-input"
                        variant="outlined"
                        value={newRecord.email}
                        onChange={onEmailChanged}
                        error={emailFieldError !== undefined && emailFieldError.length > 0}
                        helperText={emailFieldError}
                    />
                </div>
            </div>
        </Fragment>
    )
});

export default AddAdminForm;